import React from "react";
import AppBody from "../components/AppBody";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const TrainerAssignedTraining = () => {
  const state = useSelector((state) => state.organizationReducer);
  return (
    <AppBody
      loading={false}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Assigned Training List
              </h4>
              <div className="col text-right pr-0">
                <Link to={"/trainer/register"}>
                  <a
                    className="line-height-36 custom-icon mr-2"
                    title="Trainer Register"
                  >
                    <i className="feather-plus-circle"></i>
                  </a>
                </Link>
              </div>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Training </th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.bank_name}</td>
                          <td>{li.bank_address}</td>
                          <td>{li.bank_account_name}</td>
                          <td>{li.account_number}</td>
                          <td>{li.account_type}</td>
                          <td>{li.ifsc_code}</td>
                          <td>
                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Update"
                              target="_blank"
                            >
                              <i className="feather-edit"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default TrainerAssignedTraining;
